/*
semsomi AB
Copyright (c) 2016-2017
All rights reserved
*/

// import * as types from '../actions/actionTypes';

import {
  FEED_REQUEST,
  FEED_SUCCESS,
  FEED_FAILURE,
  // SEARCH_REQUEST,
  // SEARCH_SUCCESS,
  // SEARCH_FAILURE,,
  UPDATE_MENU,
  ADD_FEED_SUCCESS,
  REMOVE_FEED_SUCCESS,
  // REMOVE_FEED,
  SET_FEEDS,
  SET_TABS,
  SET_PUFFS,
  SET_PUFF,
  ORDERPUFF_SUCCESS

} from '../actions/actionTypes'

import {setting} from '../util';

let config = require('../../settings/config.json');
const adFrequency = config.ads.frequency

function removeDuplicates(puffs, newPuffs){
  //TODO: please understand that removing duplicated is good for many things (new puffs etc) but also hides a bug!
  //sometimes when scrolling very fast, two calls are made which returns two identical list of puffs!
  //this fixes the symptom but not the cause of that
  return newPuffs.filter(function(puff){
    return (puffs.findIndex(p=>p.id==puff.id) === -1)
  })
}

function addAds(feed, puffs){
  //Add Ads
  return puffs
}

const groupFilters = function(options){
  const total = Object.values(options).reduce((sum, count) => sum + count, 0);
  const percentageThreshold = 5; // 5%
  const result = {};
  let otherLanguagesCount = 0;

  for (const [lang, count] of Object.entries(options)) {
    const percentage = (count / total) * 100;
    if (percentage >= percentageThreshold) {
      result[lang] = count;
    } else {
      otherLanguagesCount += count;
    }
  }

  if (otherLanguagesCount > 0) {
    result['other'] = otherLanguagesCount;
  }

  return result 
}

const generateMenu = function(feed, user, feeds){
  // console.log(location)
  // console.log(this.props)
  // console.log( window.location.search)

  if(!feed || feed.id==="login" || feed.id==="about" || feed.noSubmenu) return [];

  if(feed.id === "profile"){
    // console.log(user)
    // console.log(feeds)
    let filters = {
      language:{

      },
      status:{
        paused:0,
        running:0
      },
      websites:{

      }
    }

    let filt = []

    if(feeds && feeds.length>10){
      feeds.forEach(f=>{

        if(f.id!=='en'){
          let lang = setting(f.articleGeneration, 'language', 'en')
          filters.language[lang] = filters.language[lang]+1 || 1 
          let status = f.enabled ? 'running' : 'paused'
          filters.status[status] = filters.status[status]+1 
          let website = f.onSubmit ? f.onSubmit.find(target=>['wp','api'].includes(target.type)) : null
          if(website){
            try{
              let domain = new URL(website.url); 
              domain = domain.hostname.replace(/^www./gi,'')
              filters.websites[domain] = filters.websites[domain]+1 || 1
            }catch(e){

            }
          }

        }
      })

      filters.language = groupFilters(filters.language)
      filters.websites = groupFilters(filters.websites)

      // console.log(Object.keys(filters.language))
      let langSelections = Object.keys(filters.language)
                          .map(l=>({type:"filter", value:'language:'+l, title:window.languages.find(la=>la.code===l) ? window.languages.find(la=>la.code===l).title : l+ (l === 'other' ? ' languages' : ''), count:filters.language[l],  group:2}))
                          .sort((a,b)=>a.title==='other languages' ? 1 : (b.count-a.count))
      
      let statusSelection = Object.keys(filters.status)
                          .map(l=>({type:"filter", faicon:'fa fa-'+({paused:'pause', running:'play'}[l]), value:'status:'+l, title:l, count:filters.status[l],  group:2}))
                          .filter(s=>s.count>0)
                          .sort((a,b)=>a.title==='other' ? 1 : (b.count-a.count))

      let websiteSelection = Object.keys(filters.websites)
                             .map(l=>({type:"filter", value:'site:'+l, title:l+ (l === 'other' ? ' websites' : ''), count:filters.websites[l],  group:2}))
                             .sort((a,b)=>a.title==='other websites' ? 1 : (b.count-a.count))

                                 
      // console.log(langSelections)
  
      filt = filt.concat(websiteSelection.length>1 ? websiteSelection : [])
                .concat(langSelections.length>1 ? langSelections : [])
                .concat(statusSelection.length>1 ? statusSelection : [])
    }

    return [
            // ...config.menus.feed, 
             
            ...(filt.length > 0 ? [{type:"filter", value:'all', faicon:'fa fa-inbox', title:'All Feeds', selected:true, group:2}].concat(filt) : []),
            
            {type:"page", value:'', faicon:'fa fa-circle', title:'All Projects', selected:true, group:1, writer:false}, 
            ...(user && user.projects ? user.projects.map(p=>({type:"page", value:p.id, faicon:'fa fa-circle', title:p.title, group:1, writer:false})) : []),
            {type:"page", value:'newproject', faicon:'fa fa-plus', title:'New Project', selected:true, group:1, writer:false}, 
            {type:"page", value:'new', faicon:'fa fa-plus', title:'New Feed', group:1, writer:false},
            ...(user && user.feeds && user.feeds.find(f=>f.project==='archive') ? [{type:"page", value:'archive', faicon:'fa fa-trash', title:'Archived', group:1, writer:false}] : []),

            {type:"page", value:'', faicon:'fa fa-inbox', title:'tabs.profile', selected:true, group:3}, 
            {type:"page", value:'settings', faicon:'glyphicon glyphicon-cog', title:'tabs.settings', group:3},
            {type:"page", value:'support', faicon:'fa fa-life-ring', title:'tabs.support', group:3},
            {type:"page", value: "logout", faicon:'fa fa-sign-out', title:'tabs.logout', group:3}
            ].filter(f=>f);
  }else if(feed.id==="search"){
    // console.log(user)
    let store = true//user ? true : false

    return config.menus.search
          .filter(m=>!m.disabled)
          .map(m=>{
      if(m.type==='feed' && m.value==='store'){
        return {...m, selected: store}
      // }else if(m.type==='feed' && m.value==='free'){
      //   return {...m, selected: !store}
      }else if(m.type==='view' && m.value==='magazine'){
        return {...m, selected:!store}
      }else if(m.type==='view' && m.value==='masonry'){
        return {...m, selected:store}
      }else{
        return m
      }
      
    })
  }else{

    var menu = []
    if(feed.info && feed.info.categories){
      // var categories = feed.info.categories.map((category)=>{
      //   return {type:"category", value: category.name, title: category.name, selected:false, group: 9}
      // })

      // // [{title:'All',value:'',type:'category',group:9, selected:true}].concat(categories)
      // menu = [{title:'All',value:'',type:'category',group:9, selected:true}].concat(menu).concat(categories)
    }

    //TODO: Change this to a better more general check
    if(feed.id && feed.id!=='en' && feed.plugins){
      // console.log(feed)
      let productFilters = JSON.parse(JSON.stringify(config.menus.myFeed))
      // .filter(f=>{
      //   if(f.value==='articlegeneration'){
      //     return feed.plugins.findIndex(p=>p.type===f.value)>-1
      //   }else if(f.value==='cluster'){
      //      return feed.plugins.findIndex(p=>p.type===f.value)>-1 || feed.plugins.findIndex(p=>p.type==='articlegeneration')>-1
      //   }else{
      //     return true
      //   }
      // })
      if(productFilters.length>1){

        var params = window.location.search
                    .slice(1)
                    .split('&')
                    .map(p => p.split('='))
                    .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});

        if(params && params.product){
          productFilters.forEach(pf=>{
             pf.selected=params.product===pf.value
          })
        }else{
          

          let human = (!user || (user && !user.curator)) && (feed.articleGeneration && feed.articleGeneration.find(sett=>!['order:0'].includes(sett.value))) ? 1 : 0
          
          if(productFilters[human]){
            productFilters.forEach(pr=>pr.selected=false)
            productFilters[human].selected = true
          }
        }
        
        menu = menu.concat(productFilters) 
      }
    }



    var settings = [...config.menus.feed.filter(m=>!m.disabled)]

    // if(!settings.find(m=>m.type==='view' && m.selected)){
    //   let masonryButton = settings.find(m=>m.type==='view' && m.value==='masonry')
    //   masonryButton.selected = true
    // }
    return menu.concat(settings)
  }
}

const getValFromMenu = (menu, type, def)=>{
  const sortObj = menu ? menu.find((m)=>(m.type===type && m.selected===true)) : null
  return sortObj ? sortObj.value : def
}

const setupFeed = (feed, user = undefined, feeds)=>{

  if(!feed.puffs && feed.id!=='login' && feed.id!=='about') feed.puffs = [];
  // if(!feed.title) feed.title = "";
  if(!feed.id) feed.id = Date.now()/1000 * Math.random();
  if(!feed.lastRequest) feed.lastRequest ={};
  if(!feed.currentRequest) feed.currentRequest ={};
  if(!feed.isFetching) feed.isFetching =false;
  if(!feed.menu) feed.menu = generateMenu(feed, user, feeds);
  if(!feed.sort) feed.sort = getValFromMenu(feed.menu, 'sort', 'popular')
  // if(!feed.feedFilter) feed.feedFilter = getValFromMenu(feed.menu, 'feed', null)
  return feed
}


const setFocus = (feeds, index)=>{
  feeds.forEach(f=>f.focus=false)
  if(typeof index === 'string'){
    // console.log('GOING TO '+index)
    // console.log('GOING TO '+feeds.findIndex(f=>f.id===index))
    // console.log('GOING TO '+feeds[feeds.findIndex(f=>f.id===index)])
    if(feeds[feeds.findIndex(f=>f.id===index)]){
      feeds[feeds.findIndex(f=>f.id===index)].focus=true
    }
  }else if(feeds[index]){
    feeds[index].focus = true
  }
  return feeds
}

const setupFeeds = (state, action, feeds) =>{
    //The feed array
      var feedResponse = action.response.feed ? action.response.feed : action.response

      // Get the index of the current feed
      const i = state.findIndex(f=>f.id===action.request.feed.id)

      const {endpoint,offset} = action.request;
      const {query,sort,categories} = action.request.feed;
      const lastRequest = {endpoint,offset,query,sort,categories};
     
      // puffs-array creation
      let puffs = [];
      
      // The current puffs
      const currentPuffs = state[i].puffs;

      if(offset && offset>0){
        // if we need to concat with new puffs, (remove dubs, add ads, concat)
        puffs = currentPuffs.concat(removeDuplicates(currentPuffs, feedResponse));
      }else{
        // if this is the first time, just add ads
        puffs = feedResponse 
      }

      // Now create the new array with the new feedobj in the correct place of the array
      return state.map((e,index)=>{
        if(index!==i || e.currentRequest.endpoint!==endpoint){return e;}
        // if(index!==i && e.currentRequest.endpoint!==endpoint){return e;}
        action.response.id = state[i].id

        var generatedM = generateMenu({articleGeneration:state[i].articleGeneration, plugins:state[i].plugins, ...action.response}, action.user, feeds)

        var newMenu = false


        if(action.response.info && (!e.menu || (e.menu && e.menu.length < generatedM.length))){
          newMenu = true
          generatedM = generatedM.filter(m=>m.type==='category').concat(e.menu)
        }

        // console.log('AFTER')
        // console.log( action)

        return {
          ...e,
          lastRequest,
          puffs,
          sort: sort,
          categories: categories,
          info: action.response.info ? action.response.info : (offset > 0 ? e.info : null),
          menu: newMenu ? generatedM : e.menu,
          isFetching:false
        }
      })
}


const setTabs = (feeds, user)=>{
  const loggedIn = user ? true : false;

  let defaultTabs = []
  let defaultFeed = window.defaultFeeds && window.defaultFeeds[0] ? window.defaultFeeds[0] : null
  if(loggedIn){
    defaultTabs = config.tabs.filter(t=>['login','about'].indexOf(t.id) === -1 ).concat({id:'profile', title: user.firstname, focus:true})
  }else{
    defaultTabs = config.tabs.map(t=>{
      if(t.id==='login'){
        t.focus = true
      }
      return t
    })
  }

  let allTabs = feeds.concat(defaultTabs)//.map(t=>(t.id==="map"?{...t,name:feeds[0].name}:t))

  //When you log, we need to maintain the main language feed (World News English)
  //This is also handled from the backend when you're already logged in
  if(defaultFeed && !allTabs.find(f=>f.id===defaultFeed.id)){
    allTabs = [defaultFeed].concat(allTabs)
  }

  if(window.search){
    const searchViewIndex = allTabs.findIndex(f=>f.type==="search");
    allTabs[searchViewIndex] = {...allTabs[searchViewIndex],...window.search}
  }

  return allTabs.map((t)=> setupFeed(t, user, feeds))
}

const setPuff = (state, action)=>{
        // console.log('HERE')
      return state.map(e=>{

        if(e.id!==action.feed.id && !['profile'].includes(e.id)){
          return e;
        }
        // console.log('HERE')
        if((e.id==='profile' && e.puffs && e.puffs[0] && e.puffs[0].feed === action.feed.id) || e.id===action.feed.id){
          // console.log(action)
          // console.log('THERE')
          // console.log(e)
          let newPuffs = []
          if(action.puff && action.puff.delete){
            // console.log('DELETE PUFF')
            newPuffs = e.puffs.filter(puff=>puff.id!==action.puff.id)
          }else{
            // console.log('FINALLY')
            newPuffs = [...e.puffs.map(puff=>puff.id===action.puff.id ? (action.partial ? {...puff, ...action.partial} : action.puff): puff)]
          }
          return {
            ...e,
            // refresh: !e.refresh,
            puffs: newPuffs
          }
        }else{
          return e
        }
      })
}


const initialState = window.feeds ? setTabs(window.feeds, window.user) : []

const feedReducer = function(state = initialState, action) {
  // console.log(action)
  // console.log(state)
  switch(action.type) {
    case FEED_REQUEST:
      return state.map(e=>{
        if(e.id!==action.request.feed.id){return e;}
        window.status=null
        return {
          ...e,
          puffs:e.puffs,//(action.request.offset===0 ? [] : e.puffs),
          isFetching:true,
          status:null,
          currentRequest:{
            endpoint:action.request.endpoint,
            offset:action.request.offset,
            query:action.request.feed.query,
            categories:action.request.feed.categories,
            sort:action.request.feed.sort
          }

        }
      })
    case FEED_SUCCESS:
      return setupFeeds(state, action)

    case FEED_FAILURE:
    // TODO: reset puffs when a new search?
      // const lastRequestFailure = {endpoint,offset,query};
      return state.map(e=>{
        if(e.id!==action.request.feed.id){return e;}
        return {
          ...e,
          lastRequest:{
            error:action.error
          },
          currentRequest:{
            error:action.error
          },

          isFetching:false
        }
      })
    case SET_PUFF:
      return setPuff(state, action)
    case SET_PUFFS:

      return state.map(e=>{
        if(e.id!==action.feed.id){return e;}
        return {
          ...e,
          puffs:[...action.puffs],
          isFetching:false,
          info: null
        }
      })

    // case types.ORDERPUFF_REQUEST:
    //   console.log('OMGOMGOMGOMGOGMOMG')
    
    // case ORDERPUFF_SUCCESS:
    //   const {response, body} = action
    //   // console.log(action)
    //   // console.log(response)
    //   if(body.id && response.status==='success'){
    //     return setPuff(state, {feed:{id:body.options.feed.id}, puff:{id:body.options.puff.id}, partial:{status:body.status}})
    //   }
    //   return state;
    
    case UPDATE_MENU:
  
      return state.map(e=>{
        if(!action.feed || (action.feed && e.id !== action.feed.id)){
          return e;
        }
        // console.log("updating menu for "+e.id)

        return {
          ...e,
          menu:[...action.menu]
        }
      })

    case ADD_FEED_SUCCESS:
      let feed = {...action.feed, dbid:action.response.id};
      let index = action.index-1;

      feed = setupFeed(feed)
   
      if(index || index===0){
        if(index<0)index=state.length+1+index;

        let newState = state.slice(0);
        newState.splice(index,0,feed)

        newState = setFocus(newState, index)

        return newState
      }else{
        return state.slice(0).concat(feed);
      }

    case REMOVE_FEED_SUCCESS:
      const indexToRemove = state.findIndex((el)=>el.id===action.feed.id)
      let newState = state.slice(0);
      newState.splice(indexToRemove, 1)
      newState.forEach(f=>f.focus=false)

      if(action.goto){
        newState = setFocus(newState, action.goto)
      }

      return newState

    case SET_FEEDS:
      // let feeds = JSON.parse(JSON.stringify(action.feeds)).map((feed,i,arr)=>setupFeed(feed, undefined, arr));
      let feeds = JSON.parse(JSON.stringify(action.feeds)).map(setupFeed);
      let defaultFeed = window.defaultFeeds && window.defaultFeeds[0] ? window.defaultFeeds[0] : null
      feeds = window.sharedFeeds ? feeds.concat(window.sharedFeeds.map(setupFeed)) : feeds
      // feeds = window.sharedFeeds ? feeds.concat(window.sharedFeeds.map((feed,i,arr)=>setupFeed(feed, undefined, arr))) : feeds
      let newState2  = feeds.concat(state.filter(f=>['profile','search','about','login'].indexOf(f.id)>-1))
      newState2 = defaultFeed ? [defaultFeed].concat(newState2) : newState2
      newState2 = newState2.filter((f,i)=>newState2.findIndex(oF=>oF.id===f.id)===i)
      newState2 = setFocus(newState2, action.goto)
      // console.log(state.length)
      // console.log(newState2.length)
      // if(newState2.length!==state.length){
        return newState2
      // }else{
        // return state
      // }

    case SET_TABS:
      return setTabs(action && action.feeds ? action.feeds : state, action.user)

    default: return state
  }
}

export default feedReducer;